export enum IngredientChoicesType {
  Pills = 'Pills',
  List = 'List',
  Steps = 'Steps',
}
